export enum adminScoutsTypes {
    FETCH_ADMIN_SCOUTS_REQUEST = "FETCH_ADMIN_SCOUTS_REQUEST",
    FETCH_ADMIN_SCOUTS_SUCCESS = "FETCH_ADMIN_SCOUTS_SUCCESS",
    FETCH_ADMIN_SCOUTS_FAILURE = "FETCH_ADMIN_SCOUTS_FAILURE",
  }